import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "radio-group-container" }
const _hoisted_2 = { class: "input-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-error mr-2" }, "*", -1)
const _hoisted_4 = ["checked"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, "Tak", -1)
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, "Nie", -1)
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { key: 0 }

import { RadioGroup, RadioGroupOption } from '@headlessui/vue';
import { useField } from 'vee-validate';
import { computed } from 'vue';

import ChildName from './ChildName.vue';
import ChildSurname from './ChildSurname.vue';
import ChildPesel from './ChildPesel.vue';
import ChildRelation from './ChildRelation.vue';
import TooltipButton from '../TooltipButton.vue';


export default {
  __name: 'ChildCare',
  setup(__props) {

const { value, errorMessage } = useField('childCare');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createTextVNode(" Opieka nad dzieckiem / członkiem rodziny "),
        _hoisted_3,
        _createVNode(TooltipButton, null, {
          tooltip: _withCtx(() => [
            _createTextVNode(" Zaznacz tak, jeśli potrzebujesz zwolnienia ze względu na opiekę nad chorą bliską osobą ")
          ]),
          _: 1
        })
      ]),
      _createVNode(_unref(RadioGroup), {
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
        class: "squared-radio-group"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(RadioGroupOption), {
            as: "label",
            class: "squared-radio-button",
            value: "yes"
          }, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                name: "childCare",
                type: "radio",
                class: "hidden",
                value: "yes",
                checked: _unref(value) === 'yes'
              }, null, 8, _hoisted_4),
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_unref(RadioGroupOption), {
            as: "label",
            class: "squared-radio-button",
            value: "no"
          }, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                name: "childCare",
                type: "radio",
                class: "hidden",
                value: "no",
                checked: _unref(value) === 'no'
              }, null, 8, _hoisted_6),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ]),
    (_unref(value) === 'yes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(ChildName),
          _createVNode(ChildSurname),
          _createVNode(ChildPesel),
          _createVNode(ChildRelation)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

}